module.exports = __webpack_public_path__ + "media/views/about/images/icons/faq_4-1b25d1c89453075ab03516af355032fd.svg";